import BaseInput from 'components/BaseInput';
import RawInput from 'components/RawInput';
import React, { FC, memo } from 'react';
import { Props } from './types';

const Input: FC<Props> = ({ input, label, meta, autocomplete, ...rest }) => (
  <BaseInput name={input.name} label={label} meta={meta}>
    <RawInput
      error={meta.error && meta.touched}
      {...input}
      autocomplete={autocomplete}
      id={input.name}
      {...rest}
    />
  </BaseInput>
);

export default memo(Input);
